<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-bar-chart-box-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">Analyse des matières premières</h4>
                                <p class="cf-modal-head__sub">Consommation théorique calculée à partir des ventes et des fiches techniques</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- ========== TOOLBAR ========== -->
                    <div class="cf-dialog-toolbar">
                        <div class="cf-toolbar-row">
                            <div class="am-field">
                                <label>Du</label>
                                <input v-model="dateDebut" type="date" class="cf-inp">
                            </div>
                            <div class="am-field">
                                <label>Au</label>
                                <input v-model="dateFin" type="date" class="cf-inp">
                            </div>
                            <div class="am-field am-field--grow">
                                <label>Entrepôt</label>
                                <select v-model="pidmag" class="cf-inp cf-select">
                                    <option value="">Tous les entrepôts</option>
                                    <option v-for="(magasin,index) of listemagasins" :key="index" :value="magasin.pid">{{ magasin.name }}</option>
                                </select>
                            </div>
                            <button @click="load" :disabled="loading" type="button" class="ti-btn ti-btn-primary-full am-btn">
                                <i class="ri-refresh-line"></i> {{ loading ? 'Calcul…' : 'Actualiser' }}
                            </button>
                        </div>
                        <div class="am-tabs">
                            <button type="button" class="am-tab" :class="{ 'am-tab--on': onglet==='matieres' }" @click="onglet='matieres'">
                                <i class="ri-flask-line"></i> Consommation par matière
                            </button>
                            <button type="button" class="am-tab" :class="{ 'am-tab--on': onglet==='plats' }" @click="onglet='plats'">
                                <i class="ri-restaurant-line"></i> Coût de revient par article
                            </button>
                            <button type="button" class="am-tab" :class="{ 'am-tab--on': onglet==='besoin' }" @click="onglet='besoin'">
                                <i class="ri-shopping-cart-2-line"></i> Prévision d'achat
                            </button>
                            <div class="search-wrap am-search">
                                <i class="ri-search-line search-icon"></i>
                                <input v-model="searchword" type="search" class="search-input" placeholder="Rechercher...">
                            </div>
                        </div>
                    </div>

                    <!-- ========== BODY ========== -->
                    <div class="cf-dialog-body">

                        <div v-if="loading" class="animate-pulse cf-skeleton">
                            <div class="cf-skeleton-bar"></div>
                            <div class="cf-skeleton-bar"></div>
                            <div class="cf-skeleton-bar"></div>
                            <div class="cf-skeleton-bar"></div>
                        </div>

                        <template v-else>

                            <!-- ===== ONGLET 1 : MATIERES ===== -->
                            <template v-if="onglet==='matieres'">

                                <div class="am-kpis">
                                    <div class="am-kpi">
                                        <span class="am-kpi__label">Coût matière sur la période</span>
                                        <b class="am-kpi__value">{{ formatMoney(coutTotalMatieres) }}</b>
                                    </div>
                                    <div class="am-kpi">
                                        <span class="am-kpi__label">Matières suivies</span>
                                        <b class="am-kpi__value">{{ matieres.length }}</b>
                                    </div>
                                    <div class="am-kpi">
                                        <span class="am-kpi__label">Stock négatif</span>
                                        <b class="am-kpi__value" :class="{ 'am-ko': nbStockNegatif>0 }">{{ nbStockNegatif }}</b>
                                    </div>
                                    <div class="am-kpi">
                                        <span class="am-kpi__label">Sans prix d'achat</span>
                                        <b class="am-kpi__value" :class="{ 'am-warn': nbSansPrix>0 }">{{ nbSansPrix }}</b>
                                    </div>
                                </div>

                                <div class="table-scroll-wrap am-scroll">
                                    <table class="am-table">
                                        <thead>
                                        <tr>
                                            <th class="th" style="width:36px"></th>
                                            <th class="th">Matière première</th>
                                            <th class="th">Unité</th>
                                            <th class="th th--right">Consommé</th>
                                            <th class="th th--right">Par jour</th>
                                            <th class="th th--right">Prix d'achat</th>
                                            <th class="th th--right">Coût</th>
                                            <th class="th" style="width:120px">Poids</th>
                                            <th class="th th--right">Stock actuel</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-if="matieresFiltrees.length">
                                            <template v-for="matiere in matieresFiltrees" :key="matiere.pid">
                                                <tr class="table-row am-row-click" @click="basculer(matiere.pid)">
                                                    <td class="td"><i :class="ouvert===matiere.pid ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i></td>
                                                    <td class="td cf-strong">{{ matiere.libelle }}</td>
                                                    <td class="td">{{ matiere.unite }}</td>
                                                    <td class="td td--right">{{ formatQte(matiere.conso) }}</td>
                                                    <td class="td td--right">{{ formatQte(matiere.parjour) }}</td>
                                                    <td class="td td--right">
                                                        <span v-if="matiere.pa>0">{{ formatPrix(matiere.pa) }}</span>
                                                        <span v-else class="cf-st cf-st--ko">Sans prix</span>
                                                    </td>
                                                    <td class="td td--right cf-strong">{{ formatMoney(matiere.cout) }}</td>
                                                    <td class="td"><div class="am-bar"><div class="am-bar__fill" :style="{ width: poids(matiere)+'%' }"></div></div></td>
                                                    <td class="td td--right">
                                                        <span v-if="matiere.stock<0" class="cf-st cf-st--ko">{{ formatQte(matiere.stock) }}</span>
                                                        <span v-else>{{ formatQte(matiere.stock) }}</span>
                                                    </td>
                                                </tr>
                                                <tr v-if="ouvert===matiere.pid" class="am-detail">
                                                    <td></td>
                                                    <td colspan="8">
                                                        <table class="am-subtable">
                                                            <thead>
                                                            <tr>
                                                                <th>Article vendu</th>
                                                                <th class="th--right">Portion par vente</th>
                                                                <th class="th--right">Quantité vendue</th>
                                                                <th class="th--right">Consommé</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr v-for="plat in matiere.plats" :key="plat.pid">
                                                                <td>{{ plat.libelle }}</td>
                                                                <td class="td--right">{{ formatQte(plat.portion) }}</td>
                                                                <td class="td--right">{{ formatQte(plat.vendus) }}</td>
                                                                <td class="td--right">{{ formatQte(plat.conso) }} {{ matiere.unite }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <tr><td colspan="9" class="td"><div class="empty-state"><div class="empty-state__icon"><i class="ri-inbox-line"></i></div><p class="empty-state__title">Aucune matière première à afficher.</p></div></td></tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                                <p class="am-note">Cliquez sur une matière pour voir les articles qui la consomment.</p>

                            </template>

                            <!-- ===== ONGLET 2 : ARTICLES ===== -->
                            <template v-if="onglet==='plats'">

                                <div class="am-kpis">
                                    <div class="am-kpi">
                                        <span class="am-kpi__label">Chiffre d'affaires des articles à fiche</span>
                                        <b class="am-kpi__value">{{ formatMoney(caTotalPlats) }}</b>
                                    </div>
                                    <div class="am-kpi">
                                        <span class="am-kpi__label">Coût matière total</span>
                                        <b class="am-kpi__value">{{ formatMoney(coutTotalPlats) }}</b>
                                    </div>
                                    <div class="am-kpi">
                                        <span class="am-kpi__label">Part moyenne du coût matière</span>
                                        <b class="am-kpi__value" :class="classePart(partMoyenne)">{{ caTotalPlats>0 ? partMoyenne+' %' : '-' }}</b>
                                    </div>
                                    <div class="am-kpi">
                                        <span class="am-kpi__label">Articles sans fiche</span>
                                        <b class="am-kpi__value" :class="{ 'am-warn': sansfiche.length>0 }">{{ sansfiche.length }}</b>
                                    </div>
                                </div>

                                <div class="table-scroll-wrap am-scroll">
                                    <table class="am-table">
                                        <thead>
                                        <tr>
                                            <th class="th">Article vendu</th>
                                            <th class="th th--right">Vendus</th>
                                            <th class="th th--right">Coût matière</th>
                                            <th class="th th--right">Prix de vente moyen</th>
                                            <th class="th th--right">Marge par vente</th>
                                            <th class="th th--right">Part du coût</th>
                                            <th class="th th--right">Coût total</th>
                                            <th class="th th--right">Marge totale</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-if="platsFiltres.length">
                                            <tr class="table-row" v-for="plat in platsFiltres" :key="plat.pid">
                                                <td class="td">
                                                    <span class="cf-strong">{{ plat.libelle }}</span>
                                                    <span v-if="plat.nbsansprix>0" class="cf-st cf-st--warn am-tag" :title="plat.nbsansprix+' matière(s) sans prix d\'achat : coût sous-estimé'">Coût incomplet</span>
                                                </td>
                                                <td class="td td--right">{{ formatQte(plat.vendus) }}</td>
                                                <td class="td td--right">{{ formatMoney(plat.coutmatiere) }}</td>
                                                <td class="td td--right">{{ plat.pvmoyen>0 ? formatMoney(plat.pvmoyen) : '-' }}</td>
                                                <td class="td td--right">{{ plat.pvmoyen>0 ? formatMoney(plat.marge) : '-' }}</td>
                                                <td class="td td--right">
                                                    <span v-if="plat.pvmoyen>0" class="cf-st" :class="badgePart(plat.part)">{{ plat.part }} %</span>
                                                    <span v-else>-</span>
                                                </td>
                                                <td class="td td--right">{{ formatMoney(plat.couttotal) }}</td>
                                                <td class="td td--right cf-strong">{{ plat.vendus>0 ? formatMoney(plat.margetotale) : '-' }}</td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr><td colspan="8" class="td"><div class="empty-state"><div class="empty-state__icon"><i class="ri-inbox-line"></i></div><p class="empty-state__title">Aucun article à afficher.</p></div></td></tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>

                                <p class="am-note">Part du coût : vert jusqu'à 35 %, orange jusqu'à 50 %, rouge au-delà. Les articles sans vente sur la période n'ont pas de prix de vente moyen.</p>

                                <div v-if="sansfiche.length" class="am-alert">
                                    <b><i class="ri-alert-line"></i> {{ sansfiche.length }} article(s) marqué(s) « fiche technique » sans aucune matière :</b>
                                    <span>{{ sansfiche.map(a => a.libelle).join(', ') }}</span>
                                </div>

                            </template>

                            <!-- ===== ONGLET 3 : PREVISION D'ACHAT ===== -->
                            <template v-if="onglet==='besoin'">

                                <div class="am-besoin-head">
                                    <div class="am-field">
                                        <label>Couvrir les besoins sur</label>
                                        <select v-model.number="horizon" class="cf-inp cf-select">
                                            <option :value="1">1 jour</option>
                                            <option :value="3">3 jours</option>
                                            <option :value="7">7 jours</option>
                                            <option :value="14">14 jours</option>
                                            <option :value="30">30 jours</option>
                                        </select>
                                    </div>
                                    <label class="cf-check">
                                        <input type="checkbox" v-model="seulementACommander"> <span>Seulement les matières à commander</span>
                                    </label>
                                    <button @click="imprimerBesoin" type="button" class="ti-btn ti-btn-light am-btn-print">
                                        <i class="ri-printer-line"></i> Imprimer la liste d'achat
                                    </button>
                                </div>

                                <div class="table-scroll-wrap am-scroll">
                                    <table class="am-table">
                                        <thead>
                                        <tr>
                                            <th class="th">Matière première</th>
                                            <th class="th">Unité</th>
                                            <th class="th th--right">Consommation par jour</th>
                                            <th class="th th--right">Besoin sur {{ horizon }} j</th>
                                            <th class="th th--right">Stock actuel</th>
                                            <th class="th th--right">Couverture</th>
                                            <th class="th th--right">À commander</th>
                                            <th class="th th--right">Coût estimé</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-if="besoinsFiltres.length">
                                            <tr class="table-row" v-for="ligne in besoinsFiltres" :key="ligne.pid">
                                                <td class="td cf-strong">{{ ligne.libelle }}</td>
                                                <td class="td">{{ ligne.unite }}</td>
                                                <td class="td td--right">{{ formatQte(ligne.parjour) }}</td>
                                                <td class="td td--right">{{ formatQte(ligne.besoin) }}</td>
                                                <td class="td td--right">
                                                    <span v-if="ligne.stock<0" class="cf-st cf-st--ko">{{ formatQte(ligne.stock) }}</span>
                                                    <span v-else>{{ formatQte(ligne.stock) }}</span>
                                                </td>
                                                <td class="td td--right">
                                                    <span v-if="ligne.stock<0" class="cf-st cf-st--warn">Stock à corriger</span>
                                                    <span v-else-if="ligne.couverture===null">-</span>
                                                    <span v-else class="cf-st" :class="badgeCouverture(ligne.couverture)">{{ formatQte(ligne.couverture) }} j</span>
                                                </td>
                                                <td class="td td--right cf-strong">{{ ligne.acommander>0 ? formatQte(ligne.acommander) : '0' }}</td>
                                                <td class="td td--right">{{ ligne.acommander>0 && ligne.pa>0 ? formatMoney(ligne.coutcommande) : '-' }}</td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr><td colspan="8" class="td"><div class="empty-state"><div class="empty-state__icon"><i class="ri-inbox-line"></i></div><p class="empty-state__title">Aucune matière à commander sur cet horizon.</p></div></td></tr>
                                        </template>
                                        </tbody>
                                        <tfoot v-if="besoinsFiltres.length">
                                        <tr>
                                            <td class="td am-total" colspan="7">Coût estimé de la commande</td>
                                            <td class="td td--right am-total">{{ formatMoney(coutCommandeTotal) }}</td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <p class="am-note">
                                    Consommation par jour = consommation de la période choisie divisée par {{ periode.nbjours }} jour(s).
                                    Quand le stock est négatif, la quantité à commander couvre seulement le besoin : corrigez d'abord le stock par un inventaire.
                                </p>

                            </template>

                        </template>

                    </div>

                    <!-- ========== FOOTER ========== -->
                    <div class="cf-dialog-foot cf-dialog-foot--split">
                        <p class="cf-foot-info">Période du <b>{{ periode.debut }}</b> au <b>{{ periode.fin }}</b> ({{ periode.nbjours }} jour(s))</p>
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>
    import {mapGetters} from "vuex";
    import {currencyFormatDE, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    const formatJour = (date) => {
        let mois=('0'+(date.getMonth()+1)).slice(-2), jour=('0'+date.getDate()).slice(-2);
        return date.getFullYear()+'-'+mois+'-'+jour;
    };

    export default {
        /* eslint-disable */
        name: "modalanalysematieres",

        computed:{
            ...mapGetters(['listeotherdatacentredeconsommation_paramcom_magasin']),

            listemagasins(){
                let data=this.listeotherdatacentredeconsommation_paramcom_magasin;
                return data && Array.isArray(data.magasin)?data.magasin:[];
            },

            mot(){
                return this.searchword.toLowerCase();
            },

            matieresFiltrees(){
                let t=this;
                if (this.mot==='') return this.matieres;
                return this.matieres.filter(function (matiere) {
                    return matiere.libelle.toLowerCase().includes(t.mot)
                });
            },

            platsFiltres(){
                let t=this;
                if (this.mot==='') return this.plats;
                return this.plats.filter(function (plat) {
                    return plat.libelle.toLowerCase().includes(t.mot)
                });
            },

            coutTotalMatieres(){
                return this.matieres.reduce(function (total,matiere) { return total+matiere.cout },0);
            },

            coutMaxMatiere(){
                return this.matieres.reduce(function (max,matiere) { return Math.max(max,matiere.cout) },0);
            },

            nbStockNegatif(){
                return this.matieres.filter(function (matiere) { return matiere.stock<0 }).length;
            },

            nbSansPrix(){
                return this.matieres.filter(function (matiere) { return !(matiere.pa>0) }).length;
            },

            caTotalPlats(){
                return this.plats.reduce(function (total,plat) { return total+plat.ca },0);
            },

            coutTotalPlats(){
                return this.plats.reduce(function (total,plat) { return total+plat.couttotal },0);
            },

            partMoyenne(){
                if (!(this.caTotalPlats>0)) return 0;
                return Math.round((this.coutTotalPlats/this.caTotalPlats)*1000)/10;
            },

            besoins(){
                let t=this;
                return this.matieres.map(function (matiere) {

                    let besoin=matiere.parjour*t.horizon,
                        stockutile=matiere.stock>0?matiere.stock:0,
                        acommander=Math.max(0,besoin-stockutile),
                        couverture=matiere.parjour>0?stockutile/matiere.parjour:null;

                    return {
                        pid:matiere.pid,
                        libelle:matiere.libelle,
                        unite:matiere.unite,
                        pa:matiere.pa,
                        parjour:matiere.parjour,
                        stock:matiere.stock,
                        besoin:besoin,
                        couverture:couverture,
                        acommander:acommander,
                        coutcommande:acommander*matiere.pa,
                    }
                }).sort(function (a,b) {
                    let ca=a.couverture===null?Infinity:a.couverture,
                        cb=b.couverture===null?Infinity:b.couverture;
                    return ca-cb;
                });
            },

            besoinsFiltres(){
                let t=this,mvalue=this.besoins;
                if (this.seulementACommander){
                    mvalue=mvalue.filter(function (ligne) { return ligne.acommander>0 });
                }
                if (this.mot!==''){
                    mvalue=mvalue.filter(function (ligne) { return ligne.libelle.toLowerCase().includes(t.mot) });
                }
                return mvalue;
            },

            coutCommandeTotal(){
                return this.besoinsFiltres.reduce(function (total,ligne) { return total+ligne.coutcommande },0);
            },
        },

        data() {
            return {
                isdisplay:false,
                loading:false,
                onglet:'matieres',
                searchword:"",
                dateDebut:"",
                dateFin:"",
                pidmag:"",
                horizon:7,
                seulementACommander:false,
                ouvert:null,
                periode:{debut:"",fin:"",nbjours:1},
                matieres:[],
                plats:[],
                sansfiche:[],
            };
        },

        methods: {

            formatMoney(value){
                return currencyFormatDE(value)
            },

            formatQte(value){
                let n=Number(value);
                if (isNaN(n)) return '0';
                return n.toLocaleString('fr-FR',{maximumFractionDigits:2});
            },

            formatPrix(value){
                let n=Number(value);
                if (isNaN(n)) return '0';
                return n.toLocaleString('fr-FR',{maximumFractionDigits:2});
            },

            poids(matiere){
                if (!(this.coutMaxMatiere>0)) return 0;
                return Math.round((matiere.cout/this.coutMaxMatiere)*100);
            },

            classePart(part){
                if (!(this.caTotalPlats>0)) return '';
                if (part>50) return 'am-ko';
                if (part>35) return 'am-warn';
                return 'am-ok';
            },

            badgePart(part){
                if (part>50) return 'cf-st--ko';
                if (part>35) return 'cf-st--warn';
                return 'cf-st--ok';
            },

            badgeCouverture(couverture){
                if (couverture<2) return 'cf-st--ko';
                if (couverture<this.horizon) return 'cf-st--warn';
                return 'cf-st--ok';
            },

            basculer(pid){
                this.ouvert=this.ouvert===pid?null:pid;
            },

            show(){

                let fin=new Date(),debut=new Date();
                debut.setDate(debut.getDate()-29);

                this.dateDebut=formatJour(debut);
                this.dateFin=formatJour(fin);
                this.pidmag="";
                this.searchword="";
                this.onglet='matieres';
                this.ouvert=null;

                this.$store.dispatch('loadlisteotherdatacentredeconsommation_paramcom_magasin')

                this.isdisplay=true;

                this.load();

            },

            close(){
                this.isdisplay=false;
            },

            async load(){

                if (this.dateDebut==="" || this.dateFin===""){
                    toastr['error']( "Veuillez choisir la période.","<b></b>");
                    return;
                }

                if (this.dateDebut>this.dateFin){
                    toastr['error']( "La date de début doit précéder la date de fin.","<b></b>");
                    return;
                }

                const t = this;
                this.loading=true;
                this.ouvert=null;

                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/analyse/'+this.$store.state.appsociete+'/'+randomString();

                try {

                    let res=await axios.post(url,{
                        dateDebut:this.dateDebut,
                        dateFin:this.dateFin,
                        pidmag:this.pidmag,
                    },{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    });

                    if (res.data.success){
                        t.periode=res.data.m.periode;
                        t.matieres=res.data.m.matieres;
                        t.plats=res.data.m.plats;
                        t.sansfiche=res.data.m.sansfiche;
                    }else{
                        toastr['error']( res.data.message || "Analyse impossible.","<b></b>");
                    }

                }catch (error) {
                    toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.","<b>Erreur</b>")
                }

                this.loading=false;

            },

            echapper(value){
                return String(value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
            },

            imprimerBesoin(){

                let t=this;
                let lignes=this.besoinsFiltres.filter(function (ligne) { return ligne.acommander>0 });

                if (lignes.length===0){
                    toastr['error']( "Aucune matière à commander sur cet horizon.","<b></b>");
                    return;
                }

                let rows=lignes.map(function (ligne,index) {
                    return '<tr><td>'+(index+1)+'</td><td>'+t.echapper(ligne.libelle)+'</td><td>'+t.echapper(ligne.unite)+'</td>'
                        +'<td class="r">'+t.formatQte(ligne.stock)+'</td>'
                        +'<td class="r">'+t.formatQte(ligne.besoin)+'</td>'
                        +'<td class="r"><b>'+t.formatQte(ligne.acommander)+'</b></td>'
                        +'<td class="r">'+(ligne.pa>0?t.formatMoney(ligne.coutcommande):'-')+'</td></tr>';
                }).join('');

                let html='<html><head><meta charset="utf-8"><title>Liste d\'achat</title><style>'
                    +'body{font-family:Arial,sans-serif;font-size:12px;color:#111;margin:24px}'
                    +'h2{margin:0 0 4px;font-size:16px}p{margin:0 0 12px;color:#444}'
                    +'table{width:100%;border-collapse:collapse}th,td{border:1px solid #999;padding:5px 8px;text-align:left}'
                    +'th{background:#eee}.r{text-align:right}tfoot td{font-weight:bold}'
                    +'</style></head><body>'
                    +'<h2>Liste d\'achat des matières premières</h2>'
                    +'<p>Besoin calculé pour '+this.horizon+' jour(s), sur la consommation du '+this.periode.debut+' au '+this.periode.fin+'</p>'
                    +'<table><thead><tr><th>N°</th><th>Matière première</th><th>Unité</th><th class="r">Stock actuel</th><th class="r">Besoin</th><th class="r">À commander</th><th class="r">Coût estimé</th></tr></thead>'
                    +'<tbody>'+rows+'</tbody>'
                    +'<tfoot><tr><td colspan="6">Total estimé</td><td class="r">'+this.formatMoney(this.coutCommandeTotal)+'</td></tr></tfoot>'
                    +'</table></body></html>';

                let fenetre=window.open('','_blank');

                if (!fenetre){
                    toastr['error']( "Le navigateur a bloqué la fenêtre d'impression.","<b></b>");
                    return;
                }

                fenetre.document.write(html);
                fenetre.document.close();
                fenetre.focus();
                fenetre.print();

            },

        },

    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; height:94vh; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1240px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-toolbar { padding:0.75rem 1.25rem 0; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; flex-wrap:wrap; }
.cf-foot-info { font-size:0.78rem; color:var(--cf-muted); margin:0; }

/* Toolbar */
.cf-toolbar-row { display:flex; gap:0.75rem; align-items:flex-end; flex-wrap:wrap; }
.am-field { display:flex; flex-direction:column; gap:3px; }
.am-field label { font-size:0.72rem; color:var(--cf-muted); }
.am-field--grow { flex:1; min-width:200px; }
.cf-inp { width:100%; height:38px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-select { cursor:pointer; }
.am-btn { height:38px; }
.cf-check { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.8rem; color:var(--cf-muted); cursor:pointer; }
.cf-check input { accent-color:rgb(var(--primary)); width:16px; height:16px; }

/* Onglets */
.am-tabs { display:flex; align-items:center; gap:0.25rem; margin-top:0.8rem; flex-wrap:wrap; }
.am-tab { display:inline-flex; align-items:center; gap:0.4rem; padding:0.6rem 0.9rem; font-size:0.82rem; font-weight:600; color:var(--cf-muted); background:none; border:none; border-bottom:2px solid transparent; cursor:pointer; transition:color .15s, border-color .15s; }
.am-tab:hover { color:rgb(var(--primary)); }
.am-tab--on { color:rgb(var(--primary)); border-bottom-color:rgb(var(--primary)); }
.search-wrap { position:relative; }
.am-search { margin-left:auto; width:240px; margin-bottom:0.4rem; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:8px 12px 8px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; background:#fff; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }

/* Indicateurs */
.am-kpis { display:grid; grid-template-columns:repeat(auto-fit,minmax(190px,1fr)); gap:0.75rem; margin-bottom:0.9rem; }
.am-kpi { background:var(--cf-surface); border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); padding:0.7rem 0.9rem; }
.am-kpi__label { display:block; font-size:0.72rem; color:var(--cf-muted); margin-bottom:2px; }
.am-kpi__value { font-size:1.1rem; font-weight:700; color:var(--cf-ink-strong); }
.am-ok { color:#15803d; }
.am-warn { color:#a16207; }
.am-ko { color:#b91c1c; }

/* Table */
.table-scroll-wrap { overflow:auto; }
.am-scroll { border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); }
.am-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:860px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 0.9rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--right { text-align:right; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.am-row-click { cursor:pointer; }
.td { padding:0.55rem 0.9rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--right { text-align:right; }
.cf-strong { font-weight:500; color:var(--cf-ink-strong); }
.am-tag { margin-left:0.4rem; }
.am-total { font-weight:700; color:var(--cf-ink-strong); background:var(--cf-surface); }
.am-bar { height:6px; border-radius:3px; background:var(--cf-surface-alt); overflow:hidden; }
.am-bar__fill { height:100%; border-radius:3px; background:rgb(var(--primary)); }

/* Détail d'une matière */
.am-detail > td { background:var(--cf-surface); padding:0.5rem 0.9rem 0.8rem; }
.am-subtable { width:100%; max-width:720px; border-collapse:collapse; font-size:0.78rem; }
.am-subtable th { text-align:left; font-weight:600; color:var(--cf-muted); padding:0.3rem 0.6rem; border-bottom:1px solid var(--cf-border); }
.am-subtable td { padding:0.3rem 0.6rem; color:var(--cf-ink); border-bottom:1px solid var(--cf-surface-alt); }
.am-subtable .th--right, .am-subtable .td--right { text-align:right; }

.am-note { font-size:0.76rem; color:var(--cf-muted); margin:0.6rem 0 0; }
.am-alert { margin-top:0.8rem; padding:0.6rem 0.8rem; border-radius:var(--cf-radius-sm); background:#fef9c3; color:#a16207; font-size:0.8rem; display:flex; flex-direction:column; gap:3px; }
.am-alert span { color:#713f12; white-space:normal; }

/* Prévision d'achat */
.am-besoin-head { display:flex; align-items:flex-end; gap:1rem; flex-wrap:wrap; margin-bottom:0.9rem; }
.am-btn-print { margin-left:auto; height:38px; }

/* Skeleton */
.cf-skeleton { padding:1rem; }
.cf-skeleton-bar { height:0.9rem; border-radius:4px; background:var(--cf-surface-alt); margin-bottom:0.9rem; }
.cf-skeleton-bar:nth-child(even) { background:#e2e8f0; }

/* Empty state */
.empty-state { padding:2rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:36px; color:var(--cf-faint); margin-bottom:10px; }
.empty-state__title { font-size:0.92rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } .am-search { margin-left:0; width:100%; } .am-btn-print { margin-left:0; } }
</style>
